import submit from '@mailobj-browser/front/js/events/types/submit.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { fromEvent } from '#utilities/js/ea/ajax.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onSubmit = object(listener, {
  type: submit,
  passive,
  task: async (
    form,
    event
  ) => {
    await fromEvent(form, event)
  }
})

export default (
  form
) => {
  onSubmit.listen(form)
}